import { AutoAwesome } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import { useClientsOverviewStore, useDrawerStore, useMessageStore } from "src/store"
import { ClientsOverviewState } from "src/store/clientsOverviewStore/types"
import { Card, Grid, Typography } from "../../basics"
import { InvestorProfileChip } from "../InvestorProfileChip"
import { ITopClientCardProps } from "./types"

const TopClientCard = (props: ITopClientCardProps) => {
    const actualContext = useMessageStore((s: any) => s.actualContext)
    const setActualContext = useMessageStore((s: any) => s.setActualContext)
    const findClientByName = useClientsOverviewStore((s: ClientsOverviewState) => s.findClientByName)
    const setJsonContext = useMessageStore((s: any) => s.setJsonContext)
    const openDrawer = useDrawerStore((s: any) => s.openDrawer)

    const handleClickAIButton = () => {
        // comentario: nao ideal, os nomes podem repetir, mas não existem ids ainda para os clientes, talvez usar contas, mas tbm pode haver mais de uma conta por cliente
        let clientData = findClientByName(props.clientName);
        if (actualContext !== props.context) {
            setJsonContext(clientData);
            setActualContext(props.context);
        }
        openDrawer();
    }

    return (
        <Card sx={{ mt: 2 }}>
            <Grid container gap={2} alignItems={"center"}>
                <Grid item>
                    <Typography variant="body1">
                        {props.clientName}
                    </Typography>
                    <Typography variant="h5" mt={1}>
                        {props.clientAmount}
                    </Typography>
                </Grid>
                <InvestorProfileChip profile={props.clientInvestProfile} />
                <IconButton onClick={handleClickAIButton}>
                    <AutoAwesome sx={{ color: '#4B88AD' }} />
                </IconButton>
            </Grid>
        </Card>
    )
}

export { TopClientCard }

